import { buildActions, makeReqCons } from 'store/actions';
import type { ReduxFunction } from 'types/redux';

const prefix = 'settings';

export const settingsConstants = {
  addTwikey: makeReqCons(`${prefix}_add_twikey`),
  // template
  templateListPage: makeReqCons(`${prefix}_template_list_page`),
  templateList: makeReqCons(`${prefix}_template_list`),
  // recovery plan
  getRecoveryPlan: makeReqCons(`${prefix}_get_recovery_plan`),
  addRecoveryPlan: makeReqCons(`${prefix}_add_recovery_plan`),
  setRecoveryPlan: makeReqCons(`${prefix}_set_recovery_plan`),
  deleteRecoveryPlan: makeReqCons(`${prefix}_delete_recovery_plan`),
  duplicateRecoveryPlan: makeReqCons(`${prefix}_duplicate_recovery-plan`),
  getPlansInvoices: makeReqCons(`${prefix}_get_plans_invoices`),
  switchPlansInvoices: makeReqCons(`${prefix}_switch_plan_invoices`),
};

type SettingsActions = {
  addTwikey: ReduxFunction;
  templateListPage: Function;
  templateList: ReduxFunction;
  addRecoveryPlan: ReduxFunction;
  setRecoveryPlan: ReduxFunction;
  getRecoveryPlan: ReduxFunction;
  deleteRecoveryPlan: ReduxFunction;
  duplicateRecoveryPlan: ReduxFunction;
  switchPlansInvoices: ReduxFunction;
  switchPlansInvoicesRes: Function;
  getPlansInvoices: ReduxFunction;
};

const settingsActions = buildActions<SettingsActions>('', settingsConstants, {});

export { settingsActions };
